import { type StoryblokProductSearchFilterPromotionIdType } from '../../../../storyblok'
import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

export const storyblokProductSearchFiltersGetPromotionId = (
  blok: StoryblokProductSearchFilterPromotionIdType,
): Partial<Pick<StoryblokProductSearchFiltersType, 'promotionId'>> => {
  const promotionId = blok.promotionId.trim()

  return promotionId ? { promotionId } : {}
}
